<template>
  <footer
    class="flex flex-col items-center justify-center space-y-2 space-x-8 p-3 text-xs text-neutral-400 sm:flex-row sm:justify-end sm:space-y-0"
  >
    <div class="flex items-center gap-x-[3px]">
      <span class="shrink-0">Made with</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="text-error-400 size-4"
      >
        <path
          fill="currentColor"
          d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53z"
        />
      </svg>
      <span class="shrink-0">in Glyfada</span>
    </div>
  </footer>
</template>

